import React, { useState } from "react";
import { Link, Redirect, useLocation, useHistory } from "react-router-dom";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import isMobilePhone from "../../../utils/isMobilePhone";

import PayungTerbang from "../../../assets/images/login-payung-terbang.svg";
import Gelombang from "../../../assets/images/login-gelombang.svg";
import tokoAll from "../../../assets/images/login-tokoo.svg";

import {
  IconButton,
  Button,
  OutlinedInput,
  InputLabel,
  InputAdornment,
  FormControl,
  Divider,
  FormHelperText,
  CircularProgress,
} from "@material-ui/core";

import { Visibility, VisibilityOff, WhatsApp, LockOutlined } from "@material-ui/icons";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

import PageLoading from "../../../components/appLoading";
import useStyles from "./styles";
import Header from "../../../components/molecules/navbarLogReg";
import Header1 from "../../../components/molecules/LoginNav/header";

import Footer from "../../../components/molecules/LoginNav/footer";

import {
  auth,
  firefunctions,
  useFirebase,
} from "../../../components/firebase/FirebaseProvider";

const NumberFormatCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        "+",
        /[1-9]/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      guide={false}
    />
  );
};

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

const Login = () => {
  const classes = useStyles();
  const [year] = useState(new Date().getFullYear());
  const theme = useTheme();
  const history = useHistory();
  const matches = useMediaQuery(theme.breakpoints.up("tablet"));
  const location = useLocation();

  const { loading, user } = useFirebase();

  const [isSubmitting, setSubmitting] = useState(false);

  const [values, setValues] = useState({
    no_hp: "",
    password: "",
    showPassword: false,
    errorStatus: false,
    errorType: "",
    errorMessage: "",
  });

  const exp = /-/g;

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorStatus: false,
      errorType: "",
      errorMessage: "",
    });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleError = (err) => {
    setValues({
      ...values,
      errorStatus: true,
      errorType:
        err === "password salah"
          ? "password"
          : err === "password atau nomor handphone tidak tepat"
            ? "wa"
            : err === "No WhatsApp wajib diisi"
              ? "wa kosong"
              : err === "Password wajib diisi"
                ? "password kosong"
                : err === "No Whatsapp tidak valid"
                  ? "wa invalid"
                  : null,
      errorMessage: err,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const { no_hp, password } = values;
      let phoneRaw = no_hp.replace(exp, "");

      if (!no_hp) {
        throw new Error("No WhatsApp wajib diisi");
      } else if (!password) {
        throw new Error("Password wajib diisi");
      } else if (!isMobilePhone(phoneRaw)) {
        throw new Error("No Whatsapp tidak valid");
      }

      const loginByPhoneAndPassword = firefunctions.httpsCallable(
        "loginByPhoneAndPassword"
      );
      const response = await loginByPhoneAndPassword({
        no_hp: phoneRaw,
        password,
      });

      await auth.signInWithCustomToken(response?.data?.custom_token ?? "token");
      // console.log("login berhasil");
    } catch (err) {
      setSubmitting(false);
      handleError(err.message);
    }
    setSubmitting(false);
  };

  if (loading) {
    return <PageLoading />;
  }

  if (user) {
    const redirectTo =
      location.state && location.state.from && location.state.from.pathname
        ? location.state.from.pathname
        : "/";
    return <Redirect to={redirectTo} />;
  }
  // #kb9NKWW22s0IXZhQ00DF-HBd2o60PQIWSu1y4hE45-1
  return (
    <div className={classes.root}>
      <div className={classes.main}>
        {matches ? (
          <Header1 nameStatus={"Login"} />
        ) : (
          <Header nameStatus={"Login"} />
        )}
        <div className={classes.body}>
          <div className={classes.box}>
            <div className={classes.box_container}>
              <div className={classes.box_head}>
                <div className={classes.box_head_logo}>
                  <img src={PayungTerbang} alt="payung_terbbangg" />
                </div>
                <div className={classes.box_head_text}>
                  <h1>Masuk ke akunmu</h1>
                  <p>
                    Belum jadi reseller?
                    <Link to="/register" className={classes.link}>
                      Daftar sekarang
                    </Link>
                  </p>
                </div>
              </div>
              <Divider />
              <div className={classes.box_body}>
                <form className={classes.box_form} onSubmit={handleSubmit}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    className={classes.input_form}
                    style={{ marginBottom: "25px" }}
                    error={
                      values.errorStatus
                        ? values.errorType === "wa" ||
                          values.errorType === "wa kosong" ||
                          values.errorType === "wa invalid"
                          ? values.errorStatus
                          : null
                        : null
                    }
                  >
                    <InputLabel htmlFor="outlined-adornment-wa">
                      Nomor WA
                    </InputLabel>
                    <OutlinedInput
                      value={values.no_hp}
                      autoFocus={values.autoFocus}
                      id="outlined-adornment-wa"
                      label="Nomor WA"
                      placeholder="+62-852-1234-5678"
                      onChange={handleChange("no_hp")}
                      disabled={isSubmitting}
                      inputComponent={NumberFormatCustom}
                      startAdornment={
                        <InputAdornment position="start">
                          <WhatsApp color="action" />
                        </InputAdornment>
                      }
                    ></OutlinedInput>
                    {values.errorStatus ? (
                      values.errorType === "wa" ||
                        values.errorType === "wa kosong" ||
                        values.errorType === "wa invalid" ? (
                        <FormHelperText>{values.errorMessage}</FormHelperText>
                      ) : null
                    ) : null}
                  </FormControl>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    className={classes.input_form}
                    style={{ marginBottom: "25px" }}
                    error={
                      values.errorStatus
                        ? values.errorType === "password" ||
                          values.errorType === "password kosong"
                          ? values.errorStatus
                          : null
                        : null
                    }
                  >
                    <InputLabel htmlFor="outlined-adornment-password">
                      Password
                    </InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-password"
                      label="Password"
                      type={values.showPassword ? "text" : "password"}
                      value={values.password}
                      autoFocus={values.autoFocus}
                      onChange={handleChange("password")}
                      disabled={isSubmitting}
                      startAdornment={
                        <InputAdornment position="start">
                          <LockOutlined color="action" />
                        </InputAdornment>
                      }
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {values.showPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                      labelWidth={70}
                      placeholder="Password"
                    />
                    {values.errorStatus ? (
                      values.errorType === "password" ||
                        values.errorType === "password kosong" ? (
                        <FormHelperText>{values.errorMessage}</FormHelperText>
                      ) : null
                    ) : null}
                  </FormControl>
                  <div className={classes.bottom_form}>
                    <div className={classes.forgot_password}>
                      <span
                        onClick={() => history.push("/login/forgot")}
                        className={classes.link}
                      >
                        Lupa password?
                      </span>
                    </div>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={isSubmitting}
                      style={{
                        position: "relative",
                        width: "100%",
                        letterSpacing: "1px",
                        fontWeight: "bold",
                        borderRadius: "8px",
                        paddingTop: "12px",
                        paddingBottom: "12px",
                        marginTop: "10px",
                        marginBottom: "20px",
                      }}
                    >
                      {isSubmitting === true && (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      )}
                      {!isSubmitting ? "masuk" : null}
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <span className={classes.copyright}>
            © Hak Cipta PT. Tokorame Anugerah Sejahtera - {year}
          </span>
          <div className={classes.gelombang}>
            <img src={Gelombang} alt="gelombang" />
          </div>
          <div className={classes.toko}>
            <img src={tokoAll} alt="tokoo" />
          </div>
        </div>
      </div>
      {matches ? <Footer /> : null}
    </div>
  );
};

export default Login;
